module.exports = __webpack_public_path__ + "img/elevator1.2305cbfd.gif";